import { useEffect } from 'react';
import { BRAND, fattahProjectTitle } from '@/config/brand';
import { getModuleEntryByErpModule } from '@/config/moduleEntries';
import { useActiveModule } from '@/hooks/useActiveModule';
import { useAppSelector } from '@/hooks/useAppSelector';

/** Browser tab title: Fattah + active project name; org name when no module is open. */
export function useWorkspaceTitle() {
  const user = useAppSelector((s) => s.auth.user);
  const activeModule = useActiveModule();

  useEffect(() => {
    if (!user) {
      document.title = BRAND.name;
      return;
    }
    if (user.masterAdmin) {
      document.title = fattahProjectTitle('Master Admin');
      return;
    }
    const projectLabel = activeModule
      ? getModuleEntryByErpModule(activeModule)?.label ?? activeModule
      : null;
    if (projectLabel) {
      document.title = fattahProjectTitle(projectLabel);
      return;
    }
    const org = user.organizationName?.trim();
    document.title = org ? `${org} · ${BRAND.name}` : BRAND.name;
  }, [user?.masterAdmin, user?.organizationName, activeModule]);
}
